<template lang="pug">
v-content
  v-toolbar.page-header(app, flat, fixed, color='white', height='105')
    v-breadcrumbs(divider='/')
      v-breadcrumbs-item
        router-link(to='/organizations')
          h2 All Organizations
      v-breadcrumbs-item(disabled='')
        h2.ma-0 {{ C.data.organization.name }}
    v-spacer
    v-btn(:to="`/organizations/organization/${C.data.organization.id}/edit`", exact='', color='primary') Edit
    v-dialog(v-model='dialog', persistent='', max-width='320', v-if='CR.show.unreleased')
      v-btn(outline, color='error', slot='activator') Remove Org
      v-card
        v-card-title.headline Are you sure you want to remove
          strong {{ C.data.organization.name }}
          | ?
        v-card-text
          | This action cannot be undone
        v-card-actions
          v-spacer
          v-btn(flat='', @click.native='dialog = false') Cancel
          v-btn(color='error', flat='', @click.native='dialog = false') Yes, remove this organization

  v-container.pa-0(fluid)
    v-layout(row, nowrap)
      v-flex
        .pb-3
          .section__title.mb-5
            .subheading
              | Info
          v-layout(row)
            v-flex(md3)
              label.pl-0 Organization Name
            v-flex(md6)
              p {{ C.data.organization.name }}

          .section__title.mb-5(v-if='C.data.organization.business_address')
            .subheading
              | Business Address

          v-layout(row v-if='C.data.organization.business_address.street1')
            v-flex(md3)
              label.pl-0 Street Address
            v-flex(md6)
              p
                | {{ C.data.organization.business_address.street1 }}
              p(v-if='C.data.organization.business_address.street2')
                | {{ C.data.organization.business_address.street2 }}

          v-layout(row v-if='C.data.organization.business_address.state_province')
            v-flex(md3)
              label.pl-0 State/Province
            v-flex(md6)
              p {{ C.data.organization.business_address.state_province }}

          v-layout(row v-if='C.data.organization.business_address.city')
            v-flex(md3)
              label.pl-0 City
            v-flex(md6)
              p {{ C.data.organization.business_address.city }}

          v-layout(row v-if='C.data.organization.business_address.country')
            v-flex(md3)
              label.pl-0 Country
            v-flex(md6)
              p {{ C.list.countries[C.data.organization.business_address.country] && C.list.countries[C.data.organization.business_address.country].name }}

          .section__title.mb-5
            .subheading
              | Admins
          v-layout.mb-3(row v-for='admin in C.data.organization.administrators_statuses', :key='admin.id', align-center)
            avatar.avatar--admin.ml-0(:username='admin.user_name', :size='48')
            v-flex.pl-3
              v-layout(row, wrap, align-center)
                v-flex(xs12)
                  h3.ma-0 {{ admin.user_name }}
                p.ma-0(v-if='admin.title')
                  label
                  | {{ admin.title }}
                p.ma-0(v-if='admin.phone')
                  span.px-3 &bull;
                  label
                  | {{ admin.phone }}

</template>

<script>
  import Avatar from 'vue-avatar'
  import globalSettings from '../../assets/global-settings.js'
  import tools from '../../assets/tools.js'
  import countryData from 'country-data'

  export default {
    components: {
      Avatar
    },
    data () {
      return {
        CR: {
          show: globalSettings.show
        },
        C: {
          data: {
            organization: {
              name: '',
              business_address: {
                street1: '',
                street2: '',
                city: '',
                state_province: '',
                country: ''
              }
            }
          },
          list: {
            countries: countryData.countries
          }
        },
        dialog: false
      }
    },
    created () {
      var component = this

      tools.getOrganization({
        id: this.$route.params.id,
        success: function (organizationData) {
          component.C.data.organization = organizationData
          component.C.data.organization.business_address = component.C.data.organization.business_address || {}
        }
      })
    }
  }
</script>


<style scoped>
  .media {
      height: 100%;
      margin: 0;
  }
  .side-drawer {
    background-color: transparent;
  }
  .chip {
    background: #e6e8eb;
  }
  .avatar--admin {
     margin-left: -12px;
  }
  .avatar--admin + p {
      font-size: 1.2em;
     }
</style>



// WEBPACK FOOTER //
// src/components/Organizations/Organization.vue